// extracted by mini-css-extract-plugin
export var gif = "_km-0";